__turbopack_context__.v({
  "gallery-chunk": "gallery-images-module__T6mL7q__gallery-chunk",
  "gallery-chunk-even": "gallery-images-module__T6mL7q__gallery-chunk-even",
  "gallery-chunk-odd": "gallery-images-module__T6mL7q__gallery-chunk-odd",
  "image-0": "gallery-images-module__T6mL7q__image-0",
  "image-1": "gallery-images-module__T6mL7q__image-1",
  "image-2": "gallery-images-module__T6mL7q__image-2",
  "image-3": "gallery-images-module__T6mL7q__image-3",
  "image-4": "gallery-images-module__T6mL7q__image-4",
  "image-5": "gallery-images-module__T6mL7q__image-5",
});
